var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#EBEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1881 14.5139L13.5812 8.8327C13.8199 8.52633 13.9048 8.17213 13.8252 7.81148C13.7562 7.48362 13.5546 7.17188 13.2522 6.93538L12.5147 6.34953C11.8727 5.83892 11.0769 5.89267 10.6206 6.47852L10.1272 7.11867C10.0635 7.19875 10.0794 7.317 10.159 7.38149C10.159 7.38149 11.4059 8.38121 11.4324 8.40271C11.5173 8.48333 11.5809 8.59083 11.5969 8.71982C11.6234 8.97244 11.4483 9.20893 11.1883 9.24118C11.0663 9.25731 10.9496 9.21968 10.8647 9.14981L9.55419 8.10709C9.49052 8.05926 9.39502 8.06947 9.34196 8.13397L6.22756 12.1651C6.02595 12.4177 5.95698 12.7456 6.02595 13.0627L6.42387 14.788C6.44509 14.8794 6.52468 14.9439 6.62018 14.9439L8.37103 14.9224C8.68937 14.917 8.98649 14.7719 9.1881 14.5139ZM11.6399 13.9766H14.4948C14.7734 13.9766 14.9999 14.2061 14.9999 14.4883C14.9999 14.771 14.7734 15 14.4948 15H11.6399C11.3613 15 11.1348 14.771 11.1348 14.4883C11.1348 14.2061 11.3613 13.9766 11.6399 13.9766Z",
    fill: "#012169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.a4ddfba2c6f56147903ec21a9e63a9da.svg";
export { ForwardRef as ReactComponent };